import { render } from "./websocket2.vue?vue&type=template&id=30252557&ts=true"
import script from "./websocket2.vue?vue&type=script&lang=ts"
export * from "./websocket2.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__